<script>
  import { Modal, openModal, closeModal } from "renderless-svelte";
  import { axiosInst } from "../credentials.js";
  import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
  } from "@rgossiaux/svelte-headlessui";
  import { fade } from "svelte/transition";
  import {
    AlertCircleIcon,
    DownloadIcon,
    PrinterIcon,
    SearchIcon,
  } from "svelte-feather-icons";
  import {
    formatMimeType,
    removeAccents,
    alphabetically,
  } from "../utils/helpers.js";
  import printJS from "print-js";
  import { element, toggle_class } from "svelte/internal";

  export let locale = "el";
  export let dark = false;
  export let client = "";
  export let theme = "blue";
  export let entranceurl = "";
  export let gsisauthurl = "";
  export let userid;

  let loggedin;
  $: if (userid == "unregistered" || userid == undefined) {
    loggedin = false;
  } else {
    loggedin = true;
  }

  $: darkMode = dark == "true";
  $: console.log("COMP - org to fetch: ", entranceurl);
  $: console.log("COMP - GSIS auth url: ", gsisauthurl);

  let allOrgData = [];
  let services = [];
  let categories = [];
  let waiting = false;

  let categoriesContainingServices = []; //The categories that after a search contain the service(s) that match the query
  let filesRequested = []; //Δικαιολογητικά

  let accordionIsOpen = []; //Boolean that manipulates the accordion's functionality
  let modalIsHidden = true; //Boolean that manipulates the modal's visibility
  let chosenService = null; //The service that a user chose by clicking on it

  let searchQuery = ""; //A variable that stores the search query given by the user
  let filteredServices = []; //The service(s) that match the search query

  let searchHidden = false;

  let inputSearchElement;

  const getServices = function () {
    waiting = true;

    fetch(entranceurl + "/registeredOrganization/" + client)
      .then(function (result) {
        console.log("COMP - fetch result: ", result);
        return result.json();
      })
      .then(function (data) {
        let tempServices = data.data.servicesProvided;

        tempServices = tempServices.filter((s) => {
          return !s.serviceName.startsWith("!");
        });

        services = tempServices.sort((a, b) =>
          alphabetically(a.serviceName, b.serviceName),
        );

        filteredServices = services;
        allOrgData = data.data;

        // 1. Split services accoording to their respective "category", keep categories in a Set (unique values)
        categories = [...new Set(services.map((el) => el.serviceCategory))];

        categories.forEach((element) => {
          accordionIsOpen.push(false);
        });

        if (categories.length == 1 && services.length <= 6) {
          searchHidden = true;
        }

        categoriesContainingServices = categories.sort((a, b) =>
          alphabetically(a, b),
        );

        // 2. Return services in an object, one for each category, which is {category name, services array}
        // the reducer function creates a new array for each different "serviceCategory" attribute.
        // Each Array is then pushed to a parent Array ( [] ), which is returned as result
        // services = data.data.servicesProvided.reduce((r, o) => {
        //   Object.entries(o).forEach(([key, val]) => {
        //     if (key === "serviceCategory") (r[val] = r[val] || []).push(o);
        //   });
        //   return r.sort();
        // }, []);

        //no errors, move to next and final step
        // selectedOrgDTO = data.data;
        // $clientTerms = selectedOrgDTO.termsMessage;
        // $clientPrivacy = selectedOrgDTO.gdprMessage;
        // $clientFooterName = selectedOrgDTO.title;
        // $currentClientGsisId = selectedOrgDTO.gsisClientId;
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      })
      .finally(function () {
        waiting = false;
      });
  };

  //api call to get registered organization data
  $: if (client && client != "" && entranceurl != "") {
    getServices();
  }

  // Function to close the modal box and its background
  function close() {
    closeModal();
    modalIsHidden = true;
    chosenService = null;
  }

  //--------------------------------- PRINT ---------------------------------
  let printable;
  let docTitle = "document";

  function printRawHTML() {
    // let re = new RegExp('^<*>$')
    // let tempPrintable = printable.innerHTML.split(re);
    // console.log(tempPrintable);

    // temp.forEach((element) => {
    //   console.log(element);
    //   let el = element.toString();

    //   if (el.indexOf("id='exclude-print'")) {
    //     element.remove();
    //   }
    // });

    // tempPrintable.childNodes = temp;

    printJS({
      type: "html",
      printable: "toprint",
      scanStyles: false,
      style:
        "@media print { @page {margin: 2cm !important; font-family: Calibri !important;} span {font-size: 16px !important; padding-bottom: 5px !important;} li {list-style-type: disc !important; list-style-position: outside !important; margin-bottom: 10px !important; margin-left: 0px !important;} .level {margin-bottom: 0px !important;} .level-left {display: flex !important; align-items: center !important; justify-content: flex-start !important;} li div span {font-size: 16px !important; font-weight: bold !important; margin-top: 0px !important; margin-right: 0.5rem !important;} li div em {font-size: 12px !important;} li p {font-size: 16px !important; margin-top: 0.5rem !important; margin-bottom: 10px !important;} h2 {font-size: 20px important;} h3 {font-size: 18px important;} }",
      ignoreElements: ["exclude-print"],
      documentTitle: docTitle,
    });
  }

  //--------------------------------- SEARCH ---------------------------------
  function find() {
    categoriesContainingServices = [];
    filteredServices = [];
    var simplifiedSearchQuery = removeAccents(searchQuery.trim()); //Remove extra spaces, accents and special letters
    var splitSearchQuery = simplifiedSearchQuery.split(" "); //Separate the search query word by word

    accordionIsOpen.forEach((element, i) => {
      accordionIsOpen[i] = true;
    });

    services.forEach((service) => {
      var simplifiedServiceName = removeAccents(service.serviceName);
      var simplifiedDescription = removeAccents(service.serviceDescription);

      //Checks if the simplifiedServiceName has all splitSearchQuery's words; if so returns true
      var containsAllInTitle = splitSearchQuery.every((queryWord) => {
        return simplifiedServiceName.includes(queryWord);
      });

      var containsAllInDescription = splitSearchQuery.every((queryWord) => {
        return simplifiedDescription.includes(queryWord);
      });

      if (containsAllInTitle || containsAllInDescription) {
        filteredServices.push(service);

        if (!categoriesContainingServices.includes(service.serviceCategory)) {
          categoriesContainingServices.push(service.serviceCategory);
        }
      }
    });
  }

  let calledFind = false;
  $: if (searchQuery) {
    calledFind = true;
    find();
  }

  $: if (calledFind && searchQuery === "") {
    closeSearch();
  }

  function closeSearch() {
    calledFind = false;
    filteredServices = services;
    categoriesContainingServices = categories;

    accordionIsOpen.forEach((element, i) => {
      accordionIsOpen[i] = false;
    });
  }

  //--------------------------------- DOWNLOAD ---------------------------------
  let headersArray = [];
  let filesReady = false;
  let response;
  const createDownloadLinkForTemplate = (file) => {
    //response needs to be an arraybuffer, in order to build the blob url
    let fileType;

    return new Promise(async (resolve, reject) => {
      try {
        const response = await $axiosInst.get(
          file.templateFileURI.concat("/content"),
          { responseType: "arraybuffer" },
        );
        if (response.status !== 200) {
          console.log(
            "Looks like there was a problem. Status Code: " + response.status,
          );
          reject();
        } else {
          console.log(response);
          //create the download URL, set the type of file it's sending
          let mimeType = formatMimeType(response.headers["content-type"]);
          file.templateURI = URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            }),
          );
          //if mimetype is of certain type, add property to file (we need it for a download bug)
          if (mimeType === "DOC" || mimeType === "DOCX" || mimeType === "ODT")
            file.type = mimeType.toLowerCase();

          resolve();
        }
      } catch (err) {
        console.log("Fetch Error :-S", err);
        reject(err);
      }
    });
  };

  const createDownloadLink = (file) => {
    return new Promise(async (resolve, reject) => {
      try {
        fetch(file.templateFileURI.concat("/content"))
          .then((tmpResponse) => {
            response = tmpResponse;
            return tmpResponse.blob();
          })
          .then((blob) => {
            // Inspect the headers in the response
            for (let entry of response.headers.entries()) {
              if (entry[0] == "content-type") headersArray.push(entry[1]);
            }

            if (response.status !== 200) {
              console.log(
                "Looks like there was a problem. Status Code: " +
                  response.status,
              );
              reject();
            } else {
              console.log(response);
              // create the download URL, set the type of file it's sending
              let mimeType = formatMimeType(headersArray[0]);
              file["templateURI"] = URL.createObjectURL(blob);

              //if mimetype is of certain type, add property to file (we need it for a download bug)
              if (
                mimeType === "DOC" ||
                mimeType === "DOCX" ||
                mimeType === "ODT" ||
                mimeType === "PDF"
              )
                file["type"] = mimeType.toLowerCase();

              resolve(file);
            }
          });
      } catch (err) {
        console.log("Fetch Error :-S", err);
        reject(err);
      }
    });
  };

  let promises = [];
  const updateFilesURL = () => {
    modalIsHidden = true; //reset flag
    if (chosenService.filesRequested.length > 0) {
      promises = [];
      for (let i = 0; i < chosenService.filesRequested.length; i++) {
        if (chosenService.filesRequested[i].templateFileURI) {
          promises.push(
            createDownloadLinkForTemplate(chosenService.filesRequested[i]),
          );
          console.log("resolving file " + i);
        }
      }

      Promise.all(promises)
        .then((results) => {
          console.log("Resolved all files " + JSON.stringify(results));
          filesRequested = chosenService.filesRequested;

          //all files resolved, you're ready to open the quickView modal
          modalIsHidden = false;
          filesReady = true;
        })
        .catch((e) => {
          // handle errors here
          console.log("Error :-S", e);
        });
    } else {
      //no files to resolve, you're ready to open the quickView modal
      modalIsHidden = false;
      filesReady = true;
    }
  };

  //--------------------------------- TAXIS ---------------------------------
  const prepareGsisLoginUrl = (org, state) => {
    //idea 1: pass organization as an argument in order to get redirectUrl and id/secret
    //idea 2: keep organization data in a cookie
    //let org = $cookies.getObject('organization');

    let requrl = gsisauthurl;
    let reqscope = "read";
    let reqresponsetype = "code";
    let reqapproval = "auto";
    let reqredirect = org.gsisRedirectUrl;
    let reqclientid = org.gsisClientId;
    let reqState = state;

    return (
      requrl +
      "?scope=" +
      reqscope +
      "&response_type=" +
      reqresponsetype +
      "&approval_prompt=" +
      reqapproval +
      "&redirect_uri=" +
      reqredirect +
      "&client_id=" +
      reqclientid +
      "&state=" +
      reqState
    );
  };

  const prepareRedirectUrl = (userid, state) => {
    console.log("COMP - inside redirecturl method");
    let url;

    let currentUrl = window.location.href.split("/").slice(0, 3);
    currentUrl = currentUrl.filter((element) => {
      return element !== "";
    });

    let clientUrl = currentUrl[0] + "//" + currentUrl[1];
    let base_url = "/client";
    let org_id = state.split("_")[0];
    let process_id = state.split("_")[1];
    console.log(
      "COMP - redirecturl",
      clientUrl +
        base_url +
        "/" +
        org_id +
        "/action/" +
        process_id +
        "/user/" +
        userid +
        "/new",
    );
    if (process_id === "0") {
      url = clientUrl + base_url + "/" + org_id + "/welcome";
    } else {
      url =
        clientUrl +
        base_url +
        "/" +
        org_id +
        "/action/" +
        process_id +
        "/user/" +
        userid +
        "/new";
    }

    return url;
  };

  const focus = (node) => {
    node.focus();
  };
</script>

<!-- Listener for when the Esc button is pressed; closes the modal -->
<svelte:window on:keyup={(ev) => ev.key === "Escape" && close()} />

<div
  class:red-theme={theme == "red"}
  class:green-theme={theme == "green"}
  class:blue-theme={theme == "blue"}
>
  <div class="disc-border">
    <!-- <h1>{$t('entrance')}</h1> -->

    {#if waiting}
      <div
        class="is-flex is-justify-content-center is-align-items-center"
        style="height: 100%;"
      >
        <div class="spinner-ball m-1 animate-bounce" />
        <div class="spinner-ball m-1 animate-bounce animate-delay-100" />
        <div class="spinner-ball m-1 animate-bounce animate-delay-200" />
      </div>
    {:else if services && services.length}
      <!-- The first page the user sees -->
      <div class="p-4">
        <!-- Search box -->
        <div
          class="has-text-center is-inline-block is-flex"
          class:hidden={searchHidden}
          style="width: 100%;"
        >
          {#if searchQuery == ""}
            <button
              class="btn-search is-flex is-align-items-center"
              aria-label="Αναζήτηση υπηρεσίας"
            >
              <SearchIcon size="24" />
            </button>
          {:else}
            <button
              class="btn-search btn-search-clr px-2 flex is-align-items-center"
              aria-label="Εκκαθάριση αναζήτησης"
              style="
                border-radius: 9999px;
                border-width: 0px;
                line-height: 1.25;
                z-index: 3; 
                font-size: 1.5rem;
                line-height: 2rem;
                height: 40px;"
              title="Εκκαθάριση Αναζήτησης"
              on:click={() => {
                searchQuery = "";
                closeSearch();
                inputSearchElement.focus();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          {/if}

          <input
            aria-label="Αναζήτηση υπηρεσίας"
            bind:value={searchQuery}
            bind:this={inputSearchElement}
            class="input-search w-full"
            name="search-box"
            style="width: 100%;"
          />
        </div>

        <!-- Checks if the organization has more than one categories; if so an accordion stracture is implemented,
          otherwise displays only the title of the single category (without the accordion) -->

        {#if categories.length > 1}
          {#if categoriesContainingServices != ""}
            <div class="mt-3">
              <!-- Iterate through categories -->
              {#each categoriesContainingServices as category, i}
                <Disclosure>
                  <DisclosureButton
                    style="padding: 15px; border-width: 0px; width: 100%; cursor: pointer;
                         --tw-border-opacity: 1;
                        border-color: rgba(243, 244, 246, var(--tw-border-opacity));
                        border-collapse: separate; 
                        border-radius: 5px !important;
                        padding-top: 0.5rem;
                        padding-bottom: 0.5rem;
                        padding-left: 1rem;
                        padding-right: 1rem;
                        font-size: 1.125rem;
                        line-height: 1.75rem;
                        background-color: white !important;"
                    onmouseover="this.style.backgroundColor='#f3f4f6';"
                    onmouseout="this.style.backgroundColor='white';"
                    on:click={() => {
                      accordionIsOpen[i] = !accordionIsOpen[i];
                    }}
                    on:keydown={(e) => {
                      if (e.keyCode && (e.keyCode == 13 || e.keyCode == 32)) {
                        accordionIsOpen[i] = !accordionIsOpen[i];
                      }
                    }}
                  >
                    <div
                      class="is-flex is-justify-content-space-between is-align-items-center is-size-6"
                      style="line-height: 2.5rem;"
                    >
                      <strong class:has-text-link={accordionIsOpen[i]}>
                        {category}
                      </strong>
                      <svg
                        style="{accordionIsOpen[i]
                          ? 'transform: rotate(0.75turn); '
                          : 'transform: rotate(0.25turn); '}
                        font-size: 1.25rem;
                        line-height: 1.75rem;"
                        width="24"
                        height="24"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke={theme}
                      >
                        <path d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </DisclosureButton>

                  {#if i != accordionIsOpen.length - 1 || (i == accordionIsOpen.length - 1 && accordionIsOpen[i])}
                    <hr class="custom-hr" style="width: 100%;" />
                  {/if}

                  <!-- Iterate through services -->
                  {#each filteredServices as service}
                    {#if service.serviceCategory == category}
                      {#if accordionIsOpen[i]}
                        <DisclosurePanel static>
                          <button
                            on:click={() => {
                              chosenService = service;
                              updateFilesURL();
                              openModal(service.serviceDescription);
                              modalIsHidden = false;
                              filesRequested = service.filesRequested;
                              docTitle = service.serviceName;
                              console.log(
                                "COMP - files requested: ",
                                filesRequested,
                              );
                            }}
                            class="light-btn has-text-left"
                            style="width: 100%;"
                          >
                            {service.serviceName}
                          </button>
                        </DisclosurePanel>
                      {/if}
                    {/if}
                  {/each}

                  {#if i != accordionIsOpen.length - 1}
                    <hr
                      class="custom-hr"
                      style="width: 100%;"
                      class:hidden={!accordionIsOpen[i]}
                    />
                  {/if}
                </Disclosure>
              {/each}
            </div>
          {:else}
            <em class="m-0 mt-4 pl-4 block"
              >Η αναζήτησή σας δεν επέστρεψε αποτελέσματα!</em
            >
          {/if}
        {:else if categories.length <= 1}
          {#if categoriesContainingServices != ""}
            {#each categoriesContainingServices as category}
              <div
                class="ml-4 py-3 has-text-weight-bold mt-3"
                style=" font-size: 1.25rem; line-height: 1.75rem;"
              >
                {category}
              </div>
              <hr class="custom-hr" />
              {#each filteredServices as service}
                {#if service.serviceCategory == category}
                  <button
                    on:click={() => {
                      chosenService = service;
                      updateFilesURL();
                      openModal(service.serviceDescription);
                      modalIsHidden = false;
                      filesRequested = service.filesRequested;
                      docTitle = service.serviceName;
                      console.log("COMP - files requested: ", filesRequested);
                    }}
                    class="light-btn has-text-left"
                    style="width: 100%;"
                  >
                    {service.serviceName}
                  </button>
                {/if}
              {/each}
            {/each}
          {:else}
            <em class="m-0 mt-4 pl-4 block"
              >Η αναζήτησή σας δεν επέστρεψε αποτελέσματα!</em
            >
          {/if}
        {/if}
      </div>

      <!-- The background behind the modal -->
      <div
        id="background"
        class="{modalIsHidden ? 'is-hidden' : ''} columns is-mobile"
        style="height: 100vh; z-index: 1; position: fixed; opacity: 0.8; z-index: 999; background-color: black; 
            top: 0px;
            right: 0px;
            bottom: 0px;
            left: 0px;
            "
        on:click={close}
      />

      <!-- The modal containing the details of the clicked service 
       is-two-fifths-widescreen is-three-fifths-desktop is-full-tablet is-full-mobile
       -->
      <div
        id="modal-box"
        class="ps-modal {modalIsHidden ? 'is-hidden' : ''}
        is-flex is-flex-direction-column is-justify-content-center
        m-auto has-text-left"
      >
        <Modal let:payload>
          {#if chosenService}
            <div
              class="wrapper"
              use:focus
              role="dialog"
              aria-modal="true"
              tabindex="-1"
              aria-live="assertive"
              aria-label="Πληροφορίες υπηρεσίας"
              style="min-height: 100%;
                    display: grid;
                    grid-template-rows: 0px 1fr auto;
                    position: relative;
                    overflow: visible;"
            >
              <header />
              <button
                aria-label="Απόκρυψη πληροφοριών"
                class="{modalIsHidden
                  ? 'is-hidden'
                  : ''} z-3 px-2 is-hidden-touch generic-btn-darker-hover
                    is-flex is-align-items-center"
                style="
                    position: absolute;
                    left: 96%;
                    bottom: 100%;
                    top: -20px;
                    height: 2.5rem;
                    width: 2.5rem;
                    cursor: pointer;
                    border-width: 0px;
                    line-height: 1.25;
                    font-size: 1.5rem;"
                on:click={close}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>

              <div
                id="toprint"
                class="px-4"
                style="overflow: auto;"
                bind:this={printable}
              >
                <h2
                  class="has-text-weight-bold pb-4 m-0 mt-5"
                  style="font-size: 1.875rem; line-height: 2.25rem;"
                >
                  {chosenService.serviceName}
                </h2>
                {#if payload}
                  <span
                    class="has-text-black my-4"
                    style="font-size: 1.25rem; line-height: 1.75rem;"
                  >
                    {@html payload}
                  </span>
                {/if}
                <hr
                  class="m-2"
                  style="height: 1px; border-width: 0px; background-color: #d1d5db;"
                />

                {#if filesRequested != 0}
                  <h3
                    class="has-text-weight-bold py-4 m-0"
                    style="font-size: 1.5rem; line-height: 2rem;"
                  >
                    Δικαιολογητικά - Επισυναπτόμενα αρχεία
                  </h3>
                {/if}

                <!-- Iterate through Δικαιολογητικά -->
                <ul class="!pl-0 !m-0 my-2 text-md">
                  {#each filesRequested as file, i}
                    <!-- Checks if the given file is obligatory or not and assigns the correspondent description next to the file's title -->
                    <li
                      class="has-text-black m-0 pb-3"
                      style="list-style-type: none; list-style-position: outside;"
                    >
                      <div
                        class="level"
                        style="margin-bottom: 0.75rem !important;"
                      >
                        <div class="level-left">
                          <div class="level-item">
                            <span
                              class="inline-flex has-text-weight-bold py-2"
                              style="font-size: 1.5rem; line-height: 2rem;"
                              >{file.fileTitle}</span
                            >
                          </div>
                          <div class="level-item">
                            {#if file.obligatory === true}
                              <em
                                class="px-3 has-text-weight-bold py-2"
                                style="background-color: #fee2e2; color: #991b1b; border-radius: 0.25rem;"
                                >Υποχρεωτικό</em
                              >
                            {:else}
                              <em
                                class="px-3 has-text-weight-bold py-2"
                                style="background-color: #d1fae5; color: #065f46; border-radius: 0.25rem;"
                                >Προαιρετικό</em
                              >
                            {/if}
                          </div>
                          <div class="level-item">
                            {#if file.templateURI != null && filesReady}
                              <a
                                class="inline-flex top-2 relative no-underline py-2"
                                id="exclude-print"
                                href={file.templateURI}
                                download={file.type
                                  ? file.fileTitle + "." + file.type
                                  : file.fileTitle}
                                target="_blank"
                              >
                                <span class="my-icon"
                                  ><DownloadIcon size="1.5x" /></span
                                >
                                &nbsp;
                                <p>(Πρότυπο έγγραφο - Οδηγίες)</p>
                              </a>
                            {:else if file.templateFileURI != null && !filesReady}
                              <div
                                class="inline-flex top-2 relative no-underline py-2"
                              >
                                <span class="my-icon"
                                  ><DownloadIcon size="1.5x" /></span
                                >
                                &nbsp;
                                <p>(Πρότυπο έγγραφο - Οδηγίες)</p>
                              </div>
                            {/if}
                          </div>
                        </div>
                      </div>
                      {#if file.fileDescription.trim() != file.fileTitle.trim()}
                        <p
                          class="my-2 has-text-grey-darker"
                          style="font-size: 1.25rem; line-height: 1.75rem;"
                        >
                          {@html file.fileDescription}
                        </p>
                      {/if}
                      {#if !(i == filesRequested.length - 1)}
                        <hr
                          aria-hidden="true"
                          id="exclude-print"
                          class="my-4"
                          style="border-width: 0px; height: 1px; background-color: #d1d5db;"
                        />
                      {/if}
                    </li>
                  {/each}
                </ul>
              </div>
              <!-- The footer of the modal; contains operating buttons to connect into the service, close the modal
                    or print the service's description bottom: 0px; left: 0px; position: absolute;-->
              <footer class="py-4" style="width: 100%; ">
                <div
                  class="is-flex is-justify-content-space-between"
                  style="flex-basis: 100%"
                >
                  <div>
                    <!-- don't let user start the service if no fields or files are requested -->
                    {#if !(chosenService.filesRequested.length === 0 && chosenService.inputFields.length === 0)}
                      <button
                        class="action-btn mx-1 mt-1 ml-3"
                        style="cursor: pointer;"
                        on:click={() => {
                          if (loggedin === false) {
                            if (
                              chosenService.authenticationRequired ==
                                "TAXID_VERIFICATION" ||
                              chosenService.authenticationRequired ==
                                "TAXID_OTP_VERIFICATION"
                            ) {
                              window.location.href = prepareGsisLoginUrl(
                                allOrgData,
                                allOrgData.id
                                  .toString()
                                  .concat("_")
                                  .concat(chosenService.id),
                              );
                            } else {
                              window.location.href = prepareRedirectUrl(
                                userid,
                                allOrgData.id
                                  .toString()
                                  .concat("_")
                                  .concat(chosenService.id),
                              );
                            }
                          } else {
                            window.location.href = prepareRedirectUrl(
                              userid,
                              allOrgData.id
                                .toString()
                                .concat("_")
                                .concat(chosenService.id),
                            );
                          }
                        }}
                      >
                        {#if loggedin === false}
                          {#if chosenService.authenticationRequired == "TAXID_VERIFICATION" || chosenService.authenticationRequired == "TAXID_OTP_VERIFICATION"}
                            <span class="is-hidden-mobile"
                              >Σύνδεση με κωδικούς TaxisNet</span
                            >
                            <span class="is-hidden-tablet"
                              >Σύνδεση με TaxisNet</span
                            >
                          {:else}Νέα Αίτηση{/if}
                        {:else}Νέα Αίτηση{/if}
                      </button>
                      <button
                        class="generic-btn mt-3 generic-btn-hover cursor-pointer"
                        on:click={close}>Άκυρο</button
                      >
                    {/if}
                  </div>

                  <!-- disabled={filesRequested == 0} title={filesRequested == 0 ? 'Χωρίς δικαιολογητικά για εκτύπωση!' : null} style={filesRequested == 0 ? 'cursor: not-allowed' : 'cursor: pointer'} -->
                  <button
                    class="generic-btn mx-3 mt-3 mr-5 is-hidden-mobile generic-btn-hover"
                    style="cursor: pointer;"
                    on:click={printRawHTML}
                  >
                    <div
                      class="is-flex is-flex-direction-row is-align-items-center"
                    >
                      <PrinterIcon size="24" />
                      <p class="pl-3 m-0">Εκτύπωση</p>
                    </div>
                  </button>

                  <button
                    class="generic-btn generic-btn-hover is-hidden-tablet mx-3 mt-3 mr-5"
                    style="cursor:pointer;"
                    on:click={printRawHTML}
                  >
                    <div
                      class="is-flex is-flex-direction-row is-align-items-center"
                    >
                      <PrinterIcon size="24" />
                    </div>
                  </button>
                </div>
              </footer>
            </div>
          {:else}
            <div
              class="is-flex is-justify-content-center is-align-items-center"
              style="height: 100%;"
            >
              <div class="spinner-ball m-1 animate-bounce" />
              <div class="spinner-ball m-1 animate-bounce animate-delay-100" />
              <div class="spinner-ball m-1 animate-bounce animate-delay-200" />
            </div>
          {/if}
        </Modal>
      </div>
    {:else}
      <div class="is-flex justify-center is-align-items-center">
        {"not.found"}
      </div>
    {/if}
  </div>
</div>

<style>
  .light-btn {
    color: blue;
    background-color: transparent;
    border-radius: 9999px !important;
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
    border-width: 0px;
  }

  .light-btn:hover {
    background-color: #eff6ff;
    cursor: pointer;
  }

  .action-btn {
    background-color: #2563eb;
    border-color: #2563eb;
    color: white;
    border-radius: 9999px !important;
    /* border-radius: 1.5rem; */
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
    border: solid;
    border-width: 1px;
    cursor: pointer;
  }

  .action-btn:hover {
    background-color: #1e40af;
    border-color: #065f46;
    color: white;
  }

  .custom-hr {
    --tw-bg-opacity: 0.2;
    background-color: rgba(59, 130, 246, var(--tw-bg-opacity));
  }

  .spinner-ball {
    background-color: #93c5fd;
    border-radius: 9999px;
  }

  .custom-hr {
    border: none;
    height: 1px;
    margin: 0px;
  }

  .disc-border {
    --tw-bg-opacity: 0.2;
    border-color: rgba(59, 130, 246, var(--tw-bg-opacity)) !important;
    border: solid;
    border-width: 1px;
    border-radius: 0.25rem;
    padding-bottom: 5px;
  }

  .generic-btn {
    cursor: pointer;
    border-color: rgb(243, 244, 246) !important;
    /* border-color:  #f3f4f6; */
    border-radius: 9999px !important;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
    background-color: white !important;
    box-shadow: none !important;
    border: solid;
    border-width: 1px;
  }

  .generic-btn:hover {
    background-color: #f3f4f6 !important;
  }

  .generic-btn-darker-hover {
    border-radius: 9999px !important;
  }
  .generic-btn-darker-hover:hover {
    background-color: #d1d5db;
  }

  .spinner-ball {
    height: 20px;
    width: 20px;
  }

  .input-search {
    height: 50px;
    border: 1px solid rgba(70, 70, 70, 0.7);
    /* opacity: 70%; */
    border-radius: 0.25rem;
    text-align: left;
    text-indent: 50px;
    font-size: large;
    background-color: transparent;
    position: relative;
    /* transition: all 500ms cubic-bezier(0, 0.11, 0.35, 2); */
  }

  .input-search:focus {
    outline: none;
    border: 1px solid blue;
    box-shadow: 0 0 10px #719ece;
    text-align: left;
    text-indent: 50px;
  }

  .input-search::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }

  .btn-search {
    width: 35px;
    height: 35px;
    margin: 9px 0 0 5px;
    border-style: none;
    font-size: 20px;
    font-weight: bold;
    outline: none;
    cursor: pointer;
    border-radius: 50%;
    position: absolute;
    color: black;
    background-color: transparent;
    pointer-events: painted;
  }

  .btn-search-clr:hover {
    background-color: #d1d5db;
  }

  .wrapper {
    min-height: 100%;
    display: grid;
    grid-template-rows: auto 1fr auto;
    position: relative;
  }

  /* for line length readability */
  span,
  em,
  p {
    display: inline-block;
    max-width: 34em;
  }
</style>
